import { render, staticRenderFns } from "./GenericHeader.vue?vue&type=template&id=a30ddf1c&scoped=true"
import script from "./GenericHeader.vue?vue&type=script&lang=ts"
export * from "./GenericHeader.vue?vue&type=script&lang=ts"
import style0 from "./GenericHeader.vue?vue&type=style&index=0&id=a30ddf1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30ddf1c",
  null
  
)

export default component.exports